<div class="scrollable-table">
  @if (loading) {
    <mat-progress-bar style="height: 5px; width: 100%" mode="indeterminate"></mat-progress-bar>
  }

  <div class="content mt-3">
    <form [formGroup]="searchFormGroup" class="p-2">
      <div class="flex-row align-items-center">
        <h1 class="large-text" style="text-align: center;">Providers</h1>

        <mat-form-field class="example-form-field ml-3" appearance="outline">
          <mat-label>First Name</mat-label>

          <input matInput type="text" formControlName="firstName">
        </mat-form-field>

        <mat-form-field class="example-form-field ml-3" appearance="outline">
          <mat-label>Last Name</mat-label>

          <input matInput type="text" formControlName="lastName">
        </mat-form-field>

        <mat-form-field class="example-form-field ml-3" appearance="outline">
          <mat-label>Stripe Account ID</mat-label>

          <input matInput type="text" formControlName="stripeAccountId">
        </mat-form-field>

        <button mat-flat-button (click)="updateSearchParams()" class="ml-3 border-2 shade">Search</button>
      </div>
    </form>

    <div class="p-2">
      <table mat-table [dataSource]="serviceProviders" class="shade">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>

          <td mat-cell *matCellDef="let element">
            {{ element.firstName + " " + element.lastName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="businessName">
          <th mat-header-cell *matHeaderCellDef>Business</th>

          <td mat-cell *matCellDef="let element">
            {{ element.businessName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="stripeAccountId">
          <th mat-header-cell *matHeaderCellDef>Stripe Account Id</th>

          <td mat-cell *matCellDef="let element">
            @if (element.stripeAccountId !== null) {
              {{ element.stripeAccountId }}
            }
            @if (element.stripeAccountId === null) {
              Not Set
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="dateCreated">
          <th mat-header-cell *matHeaderCellDef>Created</th>

          <td mat-cell *matCellDef="let element">
            {{ element.createDateUTC | date: "shortDate" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="primaryPhoneNumber">
          <th mat-header-cell *matHeaderCellDef>Primary Phone Number</th>

          <td mat-cell *matCellDef="let element">
            {{ element.primaryPhoneNumber }}
          </td>
        </ng-container>

        <ng-container matColumnDef="secondaryPhoneNumber">
          <th mat-header-cell *matHeaderCellDef>
            Secondary Phone Number
          </th>

          <td mat-cell *matCellDef="let element">
            {{ element.secondaryPhoneNumber }}
          </td>
        </ng-container>

        <ng-container matColumnDef="emailAddress">
          <th mat-header-cell *matHeaderCellDef>Email Address</th>

          <td mat-cell *matCellDef="let element">
            {{ element.emailAddress }}
          </td>
        </ng-container>

        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef>Address</th>

          <td mat-cell *matCellDef="let element">
            {{ element.address }}, {{ element.city }}, {{ element.state }} {{ element.zipCode }}
          </td>
        </ng-container>

        <ng-container matColumnDef="hasActiveServicePlan">
          <th mat-header-cell *matHeaderCellDef>Active</th>

          <td mat-cell *matCellDef="let element">
            @if (!element.hasActiveServicePlan) {
              <mat-icon class="error">clear</mat-icon>
            }

            @if (element.hasActiveServicePlan) {
              <mat-icon class="success">check</mat-icon>
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="serviceProviderColumnHeaders"></tr>

        <tr mat-row *matRowDef="let row; columns: serviceProviderColumnHeaders"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">Use search fields to find Providers</td>
        </tr>
      </table>
    </div>

    <footer class="p-2">
      <button mat-flat-button [hidden]="!moreServiceProvidersToLoad" class="mt-3 mb-3 border-2 shade" color="primary" (click)="loadMoreProviders()">Load More</button>
    </footer>
  </div>
</div>